
export const properCase = (text) => (text && typeof text === 'string') ? text.charAt(0).toUpperCase() + text.substr(1).toLowerCase() : "";

export const getCamelCase = (text) => text.charAt(0).toLowerCase() + text.substr(1).replace(/\s+/g, '')

export const getJSONfromString = (str) => str.replace(/([{,])(\s*)([A-Za-z0-9_\-]+?)\s*:/g, '$1"$3":')